import React from "react";

function QRCodeIcon () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52"
      height="51"
      fill="none"
      viewBox="0 0 52 51"
    >
      <rect
        width="39.966"
        height="39.966"
        x="6.988"
        y="4.844"
        fill="#fff"
        rx="1.998"
      ></rect>
      <path
        fill="#2D2D2D"
        d="M20.602 7.842H9.986v10.616h10.616V7.842zm-2.124 8.493h-6.37v-6.37h6.37v6.37z"
      ></path>
      <path
        fill="#2D2D2D"
        d="M16.355 12.088h-2.123v2.124h2.123v-2.124zM33.34 7.842v10.616h10.617V7.842H33.34zm8.494 8.493h-6.37v-6.37h6.37v6.37z"
      ></path>
      <path
        fill="#2D2D2D"
        d="M39.71 12.088h-2.123v2.124h2.123v-2.124zM9.986 41.813h10.616V31.197H9.986v10.616zm2.123-8.492h6.37v6.37h-6.37v-6.37z"
      ></path>
      <path
        fill="#2D2D2D"
        d="M16.355 35.444h-2.123v2.123h2.123v-2.123zM31.218 7.842H26.97v2.123h4.247V7.842zM26.971 16.335h2.123v-2.123h2.124v-2.123h-6.37V9.964h-2.123V14.212h4.246v2.123zM24.848 16.335h-2.123v2.123h2.123v-2.123zM31.218 18.458h-2.123v2.123h-6.37v2.123h8.493v-4.246zM12.109 26.95h2.123v-2.122h-2.123V20.58H9.986v8.493h2.123v-2.123zM16.355 20.581h-2.123v2.123h2.123v-2.123z"
      ></path>
      <path
        fill="#2D2D2D"
        d="M22.725 29.074h4.246v-2.123h-2.123v-2.123h-4.246V20.58h-2.124v4.247h-2.123v4.246h2.123v-2.123h4.247v2.123zM31.218 24.828h-2.123v4.246h2.123v-4.246zM29.095 31.197h-6.37v2.124h4.246v6.37h-4.246v2.122h6.37V39.69h4.246v-2.123h-4.247v-6.37z"
      ></path>
      <path
        fill="#2D2D2D"
        d="M24.848 35.444h-2.123v2.123h2.123v-2.123zM33.34 31.197h-2.123v4.247h2.124v-4.247zM41.834 35.444h-6.37v6.37h2.123v-4.247h4.247v-2.123z"
      ></path>
      <path
        fill="#2D2D2D"
        d="M43.957 39.69H39.71v2.123h4.247V39.69zM43.957 31.197h-2.123v2.124h2.123v-2.124zM35.464 33.32h2.123v-6.37h-4.246v2.124h2.123v4.247zM39.71 22.704h-2.123v-2.123h-2.123v2.123h-2.123v2.124h8.493v-2.123h2.123V20.58H39.71v2.123zM43.957 26.95H39.71v2.124h4.247v-2.123z"
      ></path>
      <path
        fill="#EE0090"
        fillRule="evenodd"
        d="M38.308 50.957h8.647a4.996 4.996 0 004.995-4.996v-8.646h-1.498v8.646a3.497 3.497 0 01-3.497 3.497h-8.647v1.499zm0-49.458h8.647a3.497 3.497 0 013.497 3.497v8.646h1.498V4.996A4.996 4.996 0 0046.955 0h-8.647v1.499zM14.635 0v1.499H5.989a3.497 3.497 0 00-3.497 3.497v8.646H.993V4.996A4.996 4.996 0 015.99 0h8.646zm0 49.458v1.499H5.989a4.996 4.996 0 01-4.996-4.996v-8.646h1.5v8.646a3.497 3.497 0 003.496 3.497h8.646z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default QRCodeIcon;
